var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nutritionist"},[_c('img',{attrs:{"src":"https://cdn-file.xiaojudai.cn/static/common/images/nutritionistBack3.jpg"}}),_c('a',{staticClass:"goNutritionist",attrs:{"href":"https://work.weixin.qq.com/ca/cawcde29576dccba42"}},[_c('img',{attrs:{"src":"https://cdn-file.xiaojudai.cn/static/common/images/goNutritionist3.png"}})])])
}]

export { render, staticRenderFns }